import { Buffer } from 'buffer';

import { Spin } from 'antd';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

// Polyfill Buffer for dependencies that use Node.js APIs (e.g., csv-parse via @repo/utils)
globalThis.Buffer = Buffer;

import { initSentryClient } from '@repo/observability/sentry';

import './globals.css';
import './i18n';
import { router } from './router';

// Initialize Sentry
initSentryClient({
  appName: 'tenant-ui',
  defaultDeploymentType: 'tenant',
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  appVersion: import.meta.env.VITE_APP_VERSION,
  deploymentType: import.meta.env.VITE_DEPLOYMENT_TYPE,
});

function LoadingFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Spin size="large" />
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <RouterProvider router={router} />
    </Suspense>
  </StrictMode>,
);
